export const uploadStatus = {
    QUEUED: 0,
    IN_PROGRESS: 1,
    COMPLETE: 2,
}